export default {
    computed: {
        isAdmin() {
            return this.$auth.user() && this.$auth.user().role_name === "Admin" ? true : false;
        }
    }
}